import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

export interface PseResult {
    title: string;
    url: string;
    displayUrl: string;
    visibleUrl: string;
    content: string;
    contentNoFormatting: string;
    titleNoFormatting: string;
}

@Injectable({
    providedIn: 'root',
})
export class PseSearchService implements OnDestroy {
    private resultsSubject = new Subject<PseResult[]>();
    private renderedSubject = new Subject<void>();
    results$ = this.resultsSubject.asObservable();
    rendered$ = this.renderedSubject.asObservable();

    constructor(private ngZone: NgZone) {}

    pushResults(results: PseResult[]): void {
        this.ngZone.run(() => {
            this.resultsSubject.next(results || []);
        });
    }

    pushRendered(): void {
        this.ngZone.run(() => {
            this.renderedSubject.next();
        });
    }

    ngOnDestroy(): void {
        this.resultsSubject.complete();
        this.renderedSubject.complete();
    }
}
